import { gql } from '@apollo/client'

export const FIND_ALL_INSTITUTIONAL_CODES = gql`
  query FindAllInstitutionalCodes($query: InstitutionalCodesQueryInput!) {
    findAllInstitutionalCodes(query: $query) {
      count
      items {
        cohort
        createdAt
        id
        remainingUserCodesCount
        studentsCount
        facultyMembersCount
        university
      }
    }
  }
`

export const FIND_ONE_INSTITUTIONAL_CODES = gql`
  query FindOneInstitutionalCodes($findOneInstitutionalCodesId: String!) {
    findOneInstitutionalCodes(id: $findOneInstitutionalCodesId) {
      cohort
      createdAt
      id
      remainingUserCodesCount
      studentsCount
      facultyMembersCount
      university
    }
  }
`

export const FIND_ALL_CODES = gql`
  query FindAllCodes($query: CodesQueryInput!) {
    findAllCodes(query: $query) {
      count
      items {
        userRole
        firstName
        lastName
        email
        id
        createdAt
        code
        activationDate
        membershipType
        duration
      }
    }
  }
`

export const CREATE_INSTITUTIONAL_CODES = gql`
  mutation CreateInstitutionalCodes($createInstitutionalCodesInput: CreateInstitutionalCodesInput!) {
    createInstitutionalCodes(createInstitutionalCodesInput: $createInstitutionalCodesInput) {
      cohort
      createdAt
      id
      remainingUserCodesCount
      studentsCount
      facultyMembersCount
      university
    }
  }
`

export const CREATE_CODES = gql`
  mutation CreateCodes($createCodesInput: CreateCodesInput!) {
    createCode(createCodesInput: $createCodesInput) {
      userRole
      firstName
      lastName
      email
      id
      createdAt
      code
      activationDate
      membershipType
    }
  }
`

export const REMOVE_CODE = gql`
  mutation RemoveCode($id: String!) {
    removeCode(id: $id) {
      raw
      affected
    }
  }
`

export const CODE_REVEAL = gql`
  mutation CodeReveal($codeRevealId: String!) {
    codeReveal(id: $codeRevealId) {
      userRole
      firstName
      lastName
      email
      id
      createdAt
      code
      activationDate
      membershipType
    }
  }
`
